// extracted by mini-css-extract-plugin
module.exports = {"md":"related-home-booking-logo_md_1B1vb","ios":"related-home-booking-logo_ios_2STtL","icon":"related-home-booking-logo_icon_15q80"};